module.exports = function() {
  return new Worker(__webpack_public_path__ + "62f2a46578c5285d23a7.worker.js");
};